import React from "react";
import Modal from "react-bootstrap/Modal";
import { Subscribe } from "unstated";
import PaymentDataContainer from "../../Stores/PaymentDataContainerStore";
import InvoiceDataContainer from "../../Stores/InvoiceDataContainerStore";

import { CreditCardModalContent } from "./";
import { myGlobals } from "../../Utils";

class CreditCardPaymentContainer extends React.Component {
  render() {
    return (
      <Subscribe to={[PaymentDataContainer]}>
        {(data) => (
          <Subscribe to={[InvoiceDataContainer]}>
            {(invdata) => (
              <Modal backdrop={!myGlobals.currentTheme==="trifectaTheme.css"}  show={data.state.creditCardCheck} size="lg" centered>
                <Modal.Body className="payment-check-modal">
                  <CreditCardModalContent
				 //commenting line 22 because we are not using this function anywhere 
                 // backButtonOnClick={DOMPurify.sanitize(this.props.backButtonOnClick)}
                    invData={invdata}
                    paymentData={data}
                    loadingTrue={data.state.creditCardCheck}
                  />
                </Modal.Body>
              </Modal>
            )}
          </Subscribe>
        )}
      </Subscribe>
    );
  }
}

export default CreditCardPaymentContainer;
